import _get from 'lodash/get';
import { getMeter } from '@surfline/web-common';
import * as spotApi from '../common/api/spot';
import * as feedAPI from '../common/api/feed';
import getUrlBuoyTitle from '../utils/getUrlBuoyTitle';
import getFeedGeotarget from '../utils/getFeedGeotarget';
import { getQueryParams } from '../selectors/router';
import { setMapLocation } from './map';
import { initializeMultiCam } from './multiCam';
import { NOT_FOUND, INTERNAL_SERVER_ERROR } from './status';
import config from '../config';

export const FETCH_SPOT_REPORT = 'FETCH_SPOT_REPORT';
export const FETCH_SPOT_REPORT_SUCCESS = 'FETCH_SPOT_REPORT_SUCCESS';

export const fetchSpotReport = ({ spotId, zoom }, callback = () => {}, cookies) => async (
  dispatch,
  getState,
) => {
  dispatch({ type: FETCH_SPOT_REPORT });
  let spotReport;
  try {
    const meter = getMeter(getState());
    const { sds, corrected } = getQueryParams(getState());
    spotReport = await spotApi.fetchReport(spotId, cookies, meter, sds, corrected);
    const { spot, report, forecast, associated } = spotReport;

    if (_get(spotReport, 'spot.cameras.length', null)) {
      dispatch(initializeMultiCam(spotReport.spot.cameras));
    }

    dispatch({
      type: FETCH_SPOT_REPORT_SUCCESS,
      data: {
        spot,
        report,
        forecast,
      },
      associated,
      legacySpotId: associated.advertising.spotId,
      legacySubregionId: associated.advertising.subregionId,
    });
  } catch (err) {
    if (400 <= err.statusCode && err.statusCode < 500) {
      return dispatch({
        type: NOT_FOUND,
        message: 'The Spot Report Could not be found',
      });
    }
    return dispatch({
      type: INTERNAL_SERVER_ERROR,
      message: 'The server could not return the Spot Report',
    });
  }

  if (spotReport && !spotReport.spot.cameras.length) {
    dispatch(
      setMapLocation({
        center: {
          lat: spotReport.spot.lat,
          lon: spotReport.spot.lon,
        },
        zoom: zoom || 12,
      }),
    );
  }
  return callback(spotReport);
};

export const FETCH_NEARBY_SPOTS = 'FETCH_NEARBY_SPOTS';
export const FETCH_NEARBY_SPOTS_SUCCESS = 'FETCH_NEARBY_SPOTS_SUCCESS';
export const FETCH_NEARBY_SPOTS_FAILURE = 'FETCH_NEARBY_SPOTS_FAILURE';

export const fetchNearbySpots = (spotId, cookies) => async (dispatch, getState) => {
  dispatch({ type: FETCH_NEARBY_SPOTS });
  try {
    const meter = getMeter(getState());
    const nearbySpots = await spotApi.fetchNearbySpots(spotId, cookies, meter);
    dispatch({
      type: FETCH_NEARBY_SPOTS_SUCCESS,
      nearbySpots,
    });
  } catch (err) {
    dispatch({
      type: FETCH_NEARBY_SPOTS_FAILURE,
      error: err,
    });
  }
};

export const FETCH_BUOYS = 'FETCH_BUOYS';
export const FETCH_BUOYS_SUCCESS = 'FETCH_BUOYS_SUCCESS';
export const FETCH_BUOYS_FAILURE = 'FETCH_BUOYS_FAILURE';
export const CLEAR_BUOYS = 'CLEAR_BUOYS';

export const fetchBuoys = (legacySpotId, legacySubregionId, { units, timezone }) => async (
  dispatch,
) => {
  dispatch({ type: FETCH_BUOYS });
  try {
    const buoyResponse = await spotApi.fetchBuoys(legacySpotId, units);
    const buoyImagePaths = buoyResponse.buoys.map(({ buoy_id: buoyId, title }) => ({
      url: `http://www.surfline.com/buoy-report/${getUrlBuoyTitle(
        title,
      )}_${legacySubregionId}_${buoyId}/`,
      img: `${config.buoyPlotApi}?buoy_id=${buoyId}&bp_timezone=${timezone}&units=${units}`,
    }));
    dispatch({
      type: FETCH_BUOYS_SUCCESS,
      buoys: buoyImagePaths,
    });
  } catch (error) {
    dispatch({
      type: FETCH_BUOYS_FAILURE,
      error,
    });
  }
};

export const clearBuoys = () => ({
  type: CLEAR_BUOYS,
});

export const FETCH_IDEAL_CONDITIONS = 'FETCH_IDEAL_CONDITIONS';
export const FETCH_IDEAL_CONDITIONS_SUCCESS = 'FETCH_IDEAL_CONDITIONS_SUCCESS';
export const FETCH_IDEAL_CONDITIONS_FAILURE = 'FETCH_IDEAL_CONDITIONS_FAILURE';

export const fetchIdealConditions = (legacySpotId) => async (dispatch) => {
  dispatch({ type: FETCH_IDEAL_CONDITIONS });
  try {
    const idealConditionsResponse = await spotApi.fetchIdealConditions(legacySpotId);
    const [
      {
        travel: { best },
      },
    ] = idealConditionsResponse;
    dispatch({
      type: FETCH_IDEAL_CONDITIONS_SUCCESS,
      idealConditions: best,
    });
  } catch (error) {
    dispatch({
      type: FETCH_IDEAL_CONDITIONS_FAILURE,
      error,
    });
  }
};

export const FETCH_FEATURED_CONTENT = 'FETCH_FEATURED_CONTENT';
export const FETCH_FEATURED_CONTENT_SUCCESS = 'FETCH_FEATURED_CONTENT_SUCCESS';
export const FETCH_FEATURED_CONTENT_FAILURE = 'FETCH_FEATURED_CONTENT_FAILURE';

export const fetchFeaturedContent = (cookies) => async (dispatch, getState) => {
  dispatch({
    type: FETCH_FEATURED_CONTENT,
  });

  try {
    const limit = 7;
    const state = getState();
    const geotarget = getFeedGeotarget(state);
    const payload = await feedAPI.fetchPromoBoxSlides(limit, cookies, geotarget);
    dispatch({
      type: FETCH_FEATURED_CONTENT_SUCCESS,
      featuredContent: payload.data.promobox,
    });
  } catch (error) {
    dispatch({
      type: FETCH_FEATURED_CONTENT_FAILURE,
      error,
    });
  }
};
